
import { defineComponent } from 'vue';

const currentDate = new Date();
const currentYear = currentDate.getFullYear();

export default defineComponent({
	data: () => ({
		currentYear,
	}),
	name: 'AppFooter',
});
